import * as React from 'react';

import { DateInput } from 'src/components';
import { IDateFiltersProps, IDateFiltersState } from '../types';
import { defaultFilters } from 'src/views/TargetCheck/services/defaultFilters';

class DateFilters extends React.Component<
  IDateFiltersProps,
  IDateFiltersState
> {
  today = defaultFilters.dateTo;
  state: IDateFiltersState = {
    ...defaultFilters,
  };

  onDateChange = (field: string, date: Date) => {
    this.setState((state) => {
      state[field] = date;
      return { ...state };
    }, this.filter);
  };

  filter = async () => {
    const { ...filters } = this.state;
    await this.props.onSubmit(filters);
  };

  render() {
    const { dateFrom, dateTo } = this.state;
    return (
      <div className="flex">
        <div className="flex items-center mr-4">
          <span className="mr-3">From</span>
          <DateInput
            selected={dateFrom}
            onChange={this.onDateChange.bind(null, 'dateFrom')}
            maxDate={dateTo}
            small={true}
            className="flex-1 py-2"
          />
        </div>
        <div className="flex items-center">
          <span className="mr-3">To</span>
          <DateInput
            selected={dateTo}
            onChange={this.onDateChange.bind(null, 'dateTo')}
            minDate={dateFrom}
            maxDate={this.today}
            small={true}
            className="flex-1 py-2"
          />
        </div>
      </div>
    );
  }
}

export default DateFilters;



// WEBPACK FOOTER //
// ./src/views/Admin/History/components/DateFilters.tsx